import React from "react";
import { EligibilityProvider } from "../../contexts/EligibilityContext";
import InModal from "../eligibility-wizard/InModal";
import Open from "./Open";

// If any paths are in this list the applynow will not appear
// We are doing this as a temp resolution to prevent the apply now button to appear on the staff page
// https://github.com/Threespot/pan-foundation/issues/1069
let blacklist = new Map([
  ['/about-pan/staff/', true],
  ['/careers/', true]
]);

const GetHelp = () => {
  const currentPath = window.location.pathname;

  if (blacklist.has(currentPath)) {
    return (
      <EligibilityProvider>
        <InModal />
    </EligibilityProvider>
    );
  }

  return (
    <EligibilityProvider>
      <Open />
      <InModal />
    </EligibilityProvider>
  );
};

export default GetHelp;
